<template>
  <div class="order-form-name mb-4 pb-4">
    <h1 class="mb-0">
      <span v-show="!titleChange">{{ newTitle }}</span>
      <span @click="titleChange = !titleChange; requiredClass = ''" class="cursor-pointer ml-2 small-icon-button" v-show="!titleChange" v-if="update_allowed">
        <editicon class="svg-18"></editicon>
      </span>
    </h1>
    <input type="text" v-model="newTitle" class="form-control mb-2" v-show="titleChange" :class="requiredClass">
    <span class="btn btn-primary" v-show="titleChange" @click="saveTitleChange()">Update Title</span>
  </div>
</template>

<script>
import editicon from "./icons/edit.vue";

export default {
  components: {editicon},
  props: ['title', 'action_url', 'update_allowed'],
  data() {
    return {
      newTitle: this.title,
      titleChange: false,
      requiredClass: '',
    }
  },
  methods: {
    saveTitleChange: function() {
      let app = this;
      if(app.newTitle != '') {
        app.titleChange = !app.titleChange
        window.axios(
            {
              method: 'POST',
              url: app.action_url,
              data: {
                title: app.newTitle
              }
            }).then(function (response) {
          let dataBack = response.data;
        });
      } else {
        app.requiredClass = 'required'
      }
    }
  }
}
</script>